import useGetNewspaperExpirationValidationRules from './useGetNewspaperExpirationValidationRules'
export default useGetNewspaperExpirationValidationRules
